<template>
  <div class="container_box">
    <div class="content pt-15">
      <!-- 内容 -->
      <div class="bold9 size20 color1 mb-20">项目名称：这是一个项目名称</div>
      <div class="flex between">
        <!-- 竞价信息 -->
        <div>
          <div class="box">
            <div>
              <span
                style="
                  font-size: 14px;
                  color: #3b426b;
                  font-weight: bold;
                  margin-bottom: 8px;
                "
                >项目信息</span
              >
              <div class="textBox flex flex-column around">
                <span>场次号：55678</span>
                <span>报价方式：连续报价</span>
                <span>竞价开始时间：10:00</span>
                <span>本次竞价时间：2小时</span>
              </div>
            </div>
            <div class="center-border"></div>

            <div>
              <span
                style="
                  font-size: 14px;
                  color: #3b426b;
                  font-weight: bold;
                  margin-bottom: 8px;
                "
                >连续报价规则</span
              >
              <div class="textBox flex flex-column around">
                <span>准备时间：60秒</span>
                <span>应价时间:90秒</span>
                <span>加速应价时间：30秒</span>
              </div>
            </div>
          </div>
          <div class="loginBox">
            <div>
              <span
                style="
                  font-size: 14px;
                  color: #3b426b;
                  font-weight: bold;
                  margin-bottom: 8px;
                "
                >连续报价规则</span
              >
              <div class="textBox textBox-border flex flex-column around">
                <span>公司名称：一一一一一一</span>
                <span>报价号码：5号</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 竞价须知 -->
        <div class="Box">
          <!-- 表格 -->
          <div class="tableBox">
            <div
              style="
                font-size: 14px;
                font-weight: bold;
                color: #3b426b;
                margin-bottom: 14px;
              "
            >
              报价记录
            </div>
            <!-- 表格 -->
            <el-table
              :header-cell-style="{
                background: '#3B426C',
                color: '#ffffff',
                padding: '0px',
                height: '40px',
              }"
              :cell-style="{ padding: '0px' }"
              :row-style="{ height: '40px' }"
              class="mb-10"
              :data="tableData"
              stripe
              style="
                font-size: 14px;
                border-radius: 20px 20px 0 0;
                border: 1px solid #3b426b;
              "
            >
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="100px"
              >
                <template></template>
              </el-table-column>
              <el-table-column prop="lie2" label="分包" align="center">
              </el-table-column>
              <el-table-column prop="lie3" label="报价人" align="center">
              </el-table-column>
              <el-table-column prop="lie4" label="报价金额" align="center">
              </el-table-column>
              <el-table-column prop="lie5" label="报价时间" align="center">
              </el-table-column>
            </el-table>
          </div>
          <!-- 整包 -->
          <div class="zhengbao">
            <div class="title size14">产品明细</div>
            <div class="flex between">
              <div class="leftTable">
                <!-- 表格 -->
                <el-table
                  :header-cell-style="{
                    background: '#3B426C',
                    color: '#ffffff',
                    padding: '0px',
                    height: '40px',
                  }"
                  :cell-style="{ padding: '0px' }"
                  :row-style="{ height: '40px' }"
                  id="tableBox"
                  class="mb-10"
                  :data="cpmxTable"
                  stripe
                >
                  <el-table-column prop="lie1" label="产品名称" align="center">
                  </el-table-column>
                  <el-table-column prop="lie2" label="产品型号" align="center">
                  </el-table-column>
                  <el-table-column prop="lie3" label="供应量" align="center">
                  </el-table-column>
                </el-table>
              </div>
              <div class="rightInfo size14 flex flex-column items-center">
                <div class="max">最高限价：100，000元</div>
                <div class="min mt-10">每次报价不低于：1，000元</div>
                <div class="current mt-20">当前最低价：100，000元</div>
                <div class="name mt-10">最低报价人：韩梅梅</div>
                <div class="date mt-10 bold">
                  应价时间： <span class="text">32 </span> 秒
                </div>
                <div class="mt-20">
                  <el-input placeholder="请输入金额" v-model="price"></el-input>
                </div>
                <div class="btn mt-15 bold pointer" @click="baoJia">报价</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //是否展开
      showAll: false,

      //表格数据
      tableData: [],
      cpmxTable: [],
      price: null,
      bid: null,
    };
  },
  created() {
    this.bid = this.$route.query.id;
  },
  computed: {
    word() {
      if (this.showAll == false) {
        return "展开";
      } else {
        return "收起";
      }
    },
  },

  methods: {
    //获取整包情况
    getZhengbaoData() {},
    closeSearch(item, i) {
      item.isStatus = !item.isStatus;
      this.fenBaoList.splice(i, 1, item);
    },
    //点击报价
    baoJia() {
      if (!this.price) {
        this.$message.closeAll();
        return this.$message.error("请输入价格");
      }
    },
    //报价确定按钮
    moneyYes(item, i) {
      item.isDialog = !item.isDialog;
      this.fenBaoList.splice(i, 1, item);
    },
    moneyNo(item, i) {
      item.price = null;
      item.isDialog = !item.isDialog;
      this.fenBaoList.splice(i, 1, item);
    },
  },
};
</script>

<style scoped lang="less">
.content_box {
  background: url("../assets/imgs/bg.png") no-repeat;
  padding-bottom: 43px;
}
.content {
  width: 1200px;
  margin: auto;
}

//隔行变色的背景色
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #f3f6fb !important;
}
//表头内边距
/deep/.el-table__header tr.el-table__header th {
  padding: 0 !important;
}
//表格内边距
/deep/.el-table__body tr.el-table__body td {
  padding: 0 !important;
}
//表头单元格右边框
/deep/.el-table th.el-table__cell > .cell {
  border-right: 1px solid #fff;
}
/deep/.el-table th.el-table__cell:last-of-type > .cell {
  border-right: none;
}
//表格单元格右边框
/deep/.el-table__cell > .cell {
  border-right: 1px solid #95b3db;
}
//最后一列不要右边框
/deep/.el-table__cell:last-of-type > .cell {
  border-right: none;
}
//表格下边框
/deep/.el-table td.el-table__cell {
  border-bottom: none;
}
//报价金额输入框
/deep/.el-input__inner {
  width: 120px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid #ccd9e9;
  &::placeholder {
    text-align: center;
    font-size: 14px;
  }
}
//左边弹框
/deep/.left {
  position: absolute;
  top: 220px;
  left: 460px;
}
//中间弹框
/deep/.center {
  position: absolute;
  top: 220px;
  left: 750px;
}
//右侧弹框
/deep/.right {
  position: absolute;
  top: 220px;
  left: 1040px;
}
//弹框标题
/deep/.el-dialog__title {
  color: #1c65c4;
  font-size: 14px;
}
//弹框头部
/deep/.el-dialog__header {
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #ccd9e9;
  line-height: 38px;
  padding: 0;
}
//弹框内容
/deep/.el-dialog__body {
  padding: 14px 0;
  color: #3b426b;
  font-size: 14px;
  text-align: center;
}
//弹框按钮
/deep/.el-button.el-button--primary {
  padding: 5px 16px;
  font-size: 14px;
  border-radius: 25px;
  background-color: #1c65c4;
  margin-right: 14px;
}
/deep/.el-button.el-button--default {
  padding: 5px 16px;
  font-size: 14px;
  border-radius: 25px;
  color: #fff;
  background-color: #ccd9e9;
  margin: 0;
}
//弹框底部
/deep/.el-dialog__footer {
  text-align: center;
  padding: 0;
  padding-bottom: 14px;
}
.Box {
  margin-left: 26px;
  background: #fff;
  //右侧表格
  .tableBox {
    padding: 20px 20px;
    box-sizing: border-box;
    width: 872px;
    height: 364px;
    border-right: 4px solid #95b3db;
    background-color: #fff;
    margin-bottom: 27px;
  }

  //整包内容
  .zhengbao {
    padding-left: 20px;
    .title {
      color: #3b426b;
      margin-bottom: 11px;
    }
    .leftTable {
      width: 556px;
      border-right: 1px solid #1c65c4;
      #tableBox {
        width: 510px;

        font-size: 14px;
        border-radius: 10px;
        border: 1px solid #1c65c4;
      }
    }
    .rightInfo {
      width: 280px;
      color: #3b426b;
      .date {
        .text {
          color: #ff0053;
          font-size: 36px;
        }
      }
      .btn {
        color: #fff;
        width: 80px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background: #1c65c4;
        border-radius: 25px;
      }
    }
  }
  .fenbaoBox-active {
    filter: blur(2px);
  }
  .fenbaoBox {
    position: relative;
    width: 280px;
    height: 411px;
    border-radius: 20px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 35px 15px;
    .price-box {
      width: 280px;
      height: 411px;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(28, 101, 196, 0.05);
      border-radius: 20px;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.6);
      filter: none;
      .dialog-box {
        width: 180px;
        height: 130px;
        background: #fff;
        .title {
          text-align: center;
          height: 38px;
          line-height: 38px;
          color: #1c65c4;
          font-size: 14px;
          font-weight: bold;
          border-bottom: 1px solid #ccd9e9;
        }
        .money {
          color: #3b426b;
          text-align: center;
        }
        .btn-box {
          .yes {
            width: 60px;
            height: 30px;
            background: #1c65c4;
            text-align: center;
            line-height: 30px;
            color: #fff;
            border-radius: 25px;
            box-sizing: border-box;
          }
          .no-yes {
            background: #ccd9e9;
          }
        }
      }
    }

    .topText {
      border-bottom: 1px solid #ccd9e9;
      box-sizing: border-box;
      padding-bottom: 24px;
      .leftText {
        height: 77px;
        box-sizing: border-box;
        padding-right: 14px;
        border-right: 1px solid #1c65c4;
        font-size: 18px;
        line-height: 77px;
        color: #1c65c4;
        margin-right: 17px;
        font-weight: bold;
      }
      .rightText {
        span {
          color: #3b426b;
          font-size: 14px;
          .iconfont {
            color: #1c65c4;
            font-size: 16px !important;
          }
        }
      }
    }
    .bottomBox {
      height: 274px;
      box-sizing: border-box;
      padding: 29px 50px;
      text-align: center;
      span {
        color: #3b426b;
        font-size: 14px;
      }
      .btn {
        width: 80px;
        height: 30px;
        margin-left: 40px;
        text-align: center;
        line-height: 30px;
        background-color: #1c65c4;
        color: #fff;
        border-radius: 25px;
        cursor: pointer;
      }
    }
  }
}
//左侧信息
.box {
  width: 298px;
  height: 518px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.loginBox {
  width: 294px;
  height: 259px;
  background-color: #fff;
  padding: 35px 22px 44px 20px;
  box-sizing: border-box;
}
.textBox {
  width: 252px;
  border-radius: 13px;
  margin-top: 8px;
  margin-bottom: 30px;
  box-sizing: border-box;
  padding: 50px 17px;
  color: #565c7f;
  font-size: 14px;
}
.textBox-border {
  border: 1px solid #95b3db;
}
.center-border {
  width: 252px;
  border: 1px solid #95b3db;
  height: 0;
  margin-bottom: 40px;
}
</style>